<template>
  <div class="big">
    <DocMsg :isFlag="doc_msg" :doctorId="doctorId"></DocMsg>
    <div class="page_title">处方记录</div>
    <div style="padding: 20px; border-radius: 5px">
      <div class="container">
        <div style="border-bottom: 1px solid #e8e9f0">
          <el-menu
            :default-active="activeIndex"
            class="el-menu-demo noneline"
            mode="horizontal"
            @select="handleSelect"
          >
            <el-menu-item index="0" class="title">全部</el-menu-item>
            <el-menu-item index="1" class="title">待取药</el-menu-item>
            <el-menu-item index="2" class="title">待审方</el-menu-item>
            <el-menu-item index="3" class="title">已通过</el-menu-item>
            <el-menu-item index="4" class="title">已抓药</el-menu-item>
            <el-menu-item index="5" class="title">已失效</el-menu-item>
          </el-menu>
        </div>
        <div style="padding: 0 24px 0 24px" class="big">
          <div class="searchbox">
            <div class="item">
              <span class="searchtitle">处方号</span>
              <el-input
                placeholder="请输入"
                v-model="pre_id"
                class="inputclass"
                @change="search"
                clearable
              ></el-input>
            </div>
            <div class="item">
              <span class="searchtitle">处方类型</span>
              <el-select
                v-model="pre_group"
                placeholder="请选择"
                class="inputclass"
                clearable
                @change="search"
              >
                <el-option
                  v-for="(item, index) in pre_type_list"
                  :key="index"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </div>
            <div class="item">
              <span class="searchtitle">患者姓名</span>
              <el-input
                placeholder="请输入"
                v-model="patient_name"
                class="inputclass"
                @change="search"
                clearable
              ></el-input>
            </div>
            <div class="item">
              <span class="searchtitle">医生姓名</span>
              <el-input
                placeholder="请输入"
                v-model="doctor_name"
                class="inputclass"
                @change="search"
                clearable
              ></el-input>
            </div>
            <div class="item">
              <span class="searchtitle">医生手机号</span>
              <el-input
                placeholder="请输入"
                v-model="doctor_phone"
                class="inputclass"
                clearable
                @change="search"
              ></el-input>
            </div>
            <div class="item">
              <span class="searchtitle">所在省市</span>
              <el-select
                v-model="province_id"
                placeholder="请选择"
                @change="search"
                class="inputclass"
                clearable
              >
                <el-option
                  v-for="item in proList"
                  :key="item.province_id"
                  :label="item.name"
                  :value="item.province_id"
                ></el-option>
              </el-select>
            </div>

            <div class="item">
              <span class="searchtitle">开方时间</span>
              <el-date-picker
                v-model="date"
                type="daterange"
                range-separator="~"
                start-placeholder="开始时间"
                end-placeholder="结束时间"
                @change="search"
                clearable
                style="width: 225px; margin-left: 12px"
              ></el-date-picker>
            </div>
            <div class="item">
              <span class="searchtitle">来源</span>
              <el-select
                v-model="pre_type"
                placeholder="请选择"
                style="width: 230px; margin-left: 10px"
                multiple
                clearable
                @change="search"
              >
                <el-option
                  v-for="item in options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </div>
            <div class="item">
              <span class="searchtitle" style="margin-right: 8px"
                >药房名称</span
              >
              <!-- <el-input
                placeholder="请输入"
                v-model="hospital_name"
                class="inputclass"
                @change="search"
                clearable
              ></el-input> -->
              <myInputSerch
                v-model="hospital_name"
                @update="search"
              ></myInputSerch>
            </div>
            <div class="item">
              <span class="searchtitle">药品剂型</span>
              <el-select
                v-model="drug_type"
                placeholder="请选择"
                class="inputclass"
                clearable
                @change="search"
              >
                <el-option
                  v-for="item in options2"
                  :key="item.drug_type"
                  :label="item.drug_type_name"
                  :value="item.drug_type"
                ></el-option>
              </el-select>
            </div>
          </div>
          <div class="flex_between" style="margin: 10px 0">
            <span>
              <el-button
                type="info"
                style="background-color: #eceff2; color: #747981; width: 90px"
                @click="search"
                size="medium"
                >查询</el-button
              >
              <el-button
                v-if="active == 1"
                type="primary"
                @click="createCode"
                :disabled="
                  module_id_array[0] ? !module_id_array.includes('474') : false
                "
                size="medium"
                >生成二维码</el-button
              >
            </span>
            <span>
              <el-button
                @click="searchDia = !searchDia"
                size="medium"
                v-if="!searchDia"
                >更多筛选 <i class="el-icon-arrow-down"></i
              ></el-button>
              <el-button
                @click="searchDia = !searchDia"
                size="medium"
                v-if="searchDia"
                >收起更多筛选 <i class="el-icon-arrow-up"></i>
              </el-button>
            </span>
          </div>
          <div class="searchbox" v-show="searchDia">
            <div class="item">
              <span class="searchtitle">云诊所名称</span>
              <el-input
                placeholder="请输入"
                v-model="org_name"
                class="inputclass"
                clearable
                @change="search"
              ></el-input>
            </div>
            <div class="item">
              <span class="searchtitle">药材保密设置</span>
              <el-select
                v-model="is_show"
                placeholder="请选择"
                class="inputclass"
                clearable
                @change="search"
              >
                <el-option
                  v-for="item in options3"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </div>
            <div class="item">
              <span>回访记录</span>
              <el-select
                v-model="is_have"
                placeholder="请选择"
                class="inputclass"
                clearable
                @change="search"
              >
                <el-option label="全部" :value="''"></el-option>
                <el-option label="无" :value="0"></el-option>
                <el-option label="有" :value="1"></el-option>
              </el-select>
            </div>
            <div class="item" v-if="is_have == 1">
              <span>回访结果</span>
              <el-input
                placeholder="请输入"
                v-model="treatment_method"
                class="inputclass"
                clearable
                @change="search"
              ></el-input>
            </div>
            <div class="item">
              <span class="searchtitle">医生确认状态</span>
              <el-select
                v-model="is_doctor_sure"
                placeholder="请选择"
                class="inputclass"
                clearable
                @change="search"
              >
                <el-option
                  v-for="item in options4"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </div>
            <div class="item">
              <span class="searchtitle">快递方式</span>
              <el-select
                v-model="delivery"
                placeholder="请选择"
                class="inputclass"
                clearable
                @change="search"
              >
                <el-option label="快递" value="1"></el-option>
                <el-option label="自提" value="2"></el-option>
                <el-option label="闪送" value="3"></el-option>
              </el-select>
            </div>
            <div class="item">
              <span class="searchtitle" style="margin-right: 10px"
                >饮片加工方式</span
              >
              <span>
                <!-- -1全部 0自煎，1代煎，2茶包 -->
                <!-- <el-radio-group v-model="drug_machining" @change="search">
                  <el-radio :label="-1">全部</el-radio>
                  <el-radio :label="2">自煎</el-radio>
                  <el-radio :label="1">代煎</el-radio>
                </el-radio-group> -->

                <el-select
                  v-model="drug_machining"
                  placeholder="请选择"
                  class="inputclass"
                  clearable
                  @change="search"
                >
                  <el-option label="全部" :value="-1"></el-option>
                  <el-option label="自煎" :value="0"></el-option>
                  <el-option label="代煎" :value="1"></el-option>
                  <el-option label="茶包" :value="2"></el-option>
                </el-select>
              </span>
            </div>
            <div class="item">
              <span class="searchtitle" style="margin-right: 10px"
                >是否测试医生</span
              >
              <el-radio-group v-model="is_test" @change="search">
                <el-radio :label="0">全部</el-radio>
                <el-radio :label="1">是</el-radio>
                <el-radio :label="2">否</el-radio>
              </el-radio-group>
            </div>
          </div>

          <div style="border: solid 1px #c9cbd6">
            <el-table
              ref="multipleTable"
              :data="tableData"
              tooltip-effect="dark"
              style="width: 100%; min-width: 1000px"
              :header-cell-style="{ background: '#F5F5F5' }"
              @selection-change="handleSelectionChange"
            >
              <el-table-column
                type="selection"
                v-if="active == 1"
              ></el-table-column>
              <el-table-column
                label="开方时间"
                prop="create_time"
                width="90px"
              ></el-table-column>
              <el-table-column label="患者信息" width="90px">
                <template slot-scope="scope">
                  <div>{{ scope.row.user_name }}</div>
                  <div>
                    <span v-if="scope.row.patient_sex == 1">男</span>
                    <span v-if="scope.row.patient_sex == 2">女</span>
                    <span style="margin-left: 10px">{{ scope.row.age }}</span>
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                label="科室"
                prop="department_name"
              ></el-table-column>
              <el-table-column label="医生信息" width="110px">
                <template slot-scope="scope">
                  <div
                    @click="showDocMsg(scope.row.doctor_id)"
                    style="cursor: pointer"
                  >
                    {{ scope.row.doctor_name }}
                  </div>
                  <div>
                    <span v-if="scope.row.doctor_sex == 1">男</span>
                    <span v-if="scope.row.doctor_sex == 2">女</span>
                    <span style="margin-left: 10px">{{ scope.row.title }}</span>
                  </div>
                  <div>{{ scope.row.phone }}</div>
                </template>
              </el-table-column>
              <el-table-column
                label="药房名称"
                prop="hospital_name"
              ></el-table-column>
              <el-table-column
                prop="province_name"
                label="所在省市"
              ></el-table-column>
              <el-table-column prop="pre_group">
                <template slot="header">
                  <div>处方类型/</div>
                  <div>药品剂型</div>
                </template>
                <template slot-scope="scope">
                  <!-- <div>{{ scope.row.pre_group | preGroupText }}</div> -->
                  <!-- <span v-if="scope.row.pre_group == 1">颗粒</span>
                  <span v-if="scope.row.pre_group == 2">饮片</span>
                  <span v-if="scope.row.pre_group == 3">膏方</span>
                  <span v-if="scope.row.pre_group == 0">养生方</span>
                  <span v-if="scope.row.pre_group == -1">成药</span> -->

                  <div>
                    {{ scope.row.drug_type_name }}
                  </div>
                  <div>{{ scope.row.drug_machining | drugMachiningText }}</div>
                  <div v-if="scope.row.pre_num > 1">
                    ({{ scope.row.pre_sort }} / {{ scope.row.pre_num }})
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                label="药品金额"
                prop="drug_price"
              ></el-table-column>
              <el-table-column
                label="诊后管理费"
                prop="consult_drug_price"
              ></el-table-column>
              <el-table-column label="诊金">
                <template slot-scope="scope">
                  <span>{{
                    scope.row.consulting_gold == "0.00"
                      ? "免费"
                      : scope.row.consulting_gold
                  }}</span>
                </template>
              </el-table-column>
              <el-table-column
                label="辅料费"
                prop="excipients_price"
              ></el-table-column>
              <el-table-column
                label="加工费"
                prop="drug_machining_price"
              ></el-table-column>
              <el-table-column label="药材保密设置" width="80px">
                <template slot-scope="scope">
                  <span v-if="scope.row.is_show == 0">仅剂量保密</span>
                  <span v-if="scope.row.is_show == 1">不保密</span>
                  <span v-if="scope.row.is_show == 2">药材保密</span>
                </template>
              </el-table-column>
              <el-table-column label="处方状态">
                <template slot-scope="scope">
                  <span v-if="scope.row.status == 1">待取药</span>
                  <span v-if="scope.row.status == 2">待审方</span>
                  <span v-if="scope.row.status == 3">已通过</span>
                  <span v-if="scope.row.status == 4">已抓药</span>
                  <span v-if="scope.row.status == 5">已失效</span>
                  <span v-if="scope.row.status == 6">已失效</span>
                  <span v-if="scope.row.status == 7">已失效</span>
                  <span v-if="scope.row.status == 8">已失效</span>
                  <span v-if="scope.row.status == 9">已失效</span>
                  <div
                    v-if="scope.row.pre_type == 9 || scope.row.pre_type == 11"
                  >
                    <div v-if="scope.row.is_doctor_sure == 1">(无需确认)</div>
                    <div v-if="scope.row.is_doctor_sure == 2">(待确认)</div>
                    <div v-if="scope.row.is_doctor_sure == 3">(已确认通过)</div>
                    <div v-if="scope.row.is_doctor_sure == 4">(已确认作废)</div>
                  </div>
                  <div v-if="scope.row.ass_id > 0">
                    <div v-if="scope.row.is_doctor_sure == 1">(无需确认)</div>
                    <div v-if="scope.row.is_doctor_sure == 2">(待确认)</div>
                    <div v-if="scope.row.is_doctor_sure == 3">(已确认通过)</div>
                    <div v-if="scope.row.is_doctor_sure == 4">(已确认作废)</div>
                  </div>
                </template>
              </el-table-column>
              <el-table-column label="处方来源">
                <template slot-scope="scope">
                  <span v-if="scope.row.pre_type == 1">
                    <span v-if="scope.row.web_pre_type == 1">web问诊开方</span>
                    <span v-else>问诊开方</span>
                  </span>
                  <span v-if="scope.row.pre_type == 2">
                    <span v-if="scope.row.web_pre_type == 1">web在线开方</span>
                    <span v-else>直接开方</span>
                  </span>
                  <span v-if="scope.row.pre_type == 3">重新开方</span>
                  <span v-if="scope.row.pre_type == 4">云诊所开方</span>
                  <span v-if="scope.row.pre_type == 5">
                    <span v-if="scope.row.web_pre_type == 1"
                      >web手机号开方</span
                    >
                    <span v-else>手机号开方</span>
                  </span>
                  <span v-if="scope.row.pre_type == 6">
                    <span v-if="scope.row.web_pre_type == 1">web微信开方</span>
                    <span v-else>{{
                      !scope.row.is_wx_pre ? "微信开方" : "微信拍照"
                    }}</span>
                  </span>
                  <span v-if="scope.row.pre_type == 7">视频开方</span>
                  <span v-if="scope.row.pre_type == 8">按方购药</span>
                  <span v-if="scope.row.pre_type == 9">拍方购药</span>
                  <span v-if="scope.row.pre_type == 10">开放平台开方</span>
                  <span v-if="scope.row.pre_type == 11">医生拍照开方</span>
                  <span v-if="scope.row.pre_type == 12">医生协定方开方</span>

                  <div v-if="scope.row.org_name">{{ scope.row.org_name }}</div>
                </template>
              </el-table-column>

              <el-table-column label="操作" fixed="right">
                <template slot-scope="scope">
                  <el-button
                    type="text"
                    @click="toDetail(scope.row.pre_id)"
                    :disabled="
                      module_id_array[0]
                        ? !module_id_array.includes('56')
                        : false
                    "
                    >查看处方</el-button
                  >
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div style="margin-top: 24px">
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="currentPage"
              :page-sizes="[10, 20, 50, 100]"
              :page-size="pagesize"
              layout="total, sizes, prev, pager, next, jumper"
              :total="totalNum"
            ></el-pagination>
          </div>
          <!-- 生成二维码弹窗 -->
          <el-dialog
            title="对公转账二维码记录"
            :visible.sync="codebox"
            width="580px"
            :close-on-click-modal="false"
          >
            <div style="padding: 20px">
              <div
                class="flex_between"
                style="text-align: left; font-size: 15px"
              >
                <div>
                  <div>
                    <span style="display: inline-block; width: 100px"
                      >处方总金额</span
                    >
                    <span>{{ codeInfo.total_price }}</span>
                  </div>
                  <div style="margin: 10px 0">
                    <span style="display: inline-block; width: 100px"
                      >处方数量</span
                    >
                    <span>{{ codeInfo.total_num }}</span>
                  </div>
                  <div>
                    <span style="display: inline-block; width: 100px"
                      >转账备注</span
                    >
                    <span>{{ codeInfo.remark }}</span>
                  </div>
                </div>
                <div>
                  <img
                    :src="codeInfo.qrcode"
                    alt
                    style="width: 130px; height: 130px"
                  />
                </div>
              </div>

              <div style="border: solid 1px #c9cbd6; margin-top: 10px">
                <el-table
                  ref="multipleTable"
                  :data="codeInfo.list"
                  tooltip-effect="dark"
                  style="width: 100%"
                  :header-cell-style="{ background: '#F5F5F5' }"
                >
                  <el-table-column
                    label="开方时间"
                    prop="create_time"
                    width="145"
                  ></el-table-column>
                  <el-table-column
                    label="患者姓名"
                    prop="user_name"
                  ></el-table-column>
                  <el-table-column
                    label="医生姓名"
                    prop="doctor_name"
                  ></el-table-column>
                  <el-table-column
                    label="处方号"
                    prop="pre_id"
                  ></el-table-column>
                  <el-table-column
                    label="处方金额"
                    prop="amount"
                  ></el-table-column>
                </el-table>
              </div>
            </div>
          </el-dialog>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import myInputSerch from "@/components/myInputSerch";
import platform from "../../../api/platform";
import yewu from "../../../api/yewu";
import dayjs from "dayjs";
import DocMsg from "../../../components/common/DocMsg.vue";
export default {
  data() {
    return {
      activeIndex: "0",
      active: "0",
      date: [],
      searchDia: false,
      totalNum: 0,
      patient_name: "",
      doctor_name: "",
      doctor_phone: "",
      currentPage: 1,
      pagesize: 10,
      drug_type: "",
      tableData: [],
      pre_type: [],
      org_name: "",
      is_show: "",
      province_id: "",
      proList: [],
      pre_group: "",
      pre_id: "",
      hospital_name: "",
      delivery: "",
      is_doctor_sure: "",
      is_have: "",
      action_type: "",
      treatment_method: "",
      options: [
        {
          value: 1,
          label: "问诊开方",
        },
        {
          value: 2,
          label: "直接开方",
        },
        {
          value: 3,
          label: "重新开方",
        },
        {
          value: 4,
          label: "云诊所开方",
        },
        {
          value: 5,
          label: "手机号开方",
        },
        {
          value: 6,
          label: "微信开方",
        },
        {
          value: 7,
          label: "视频问诊开方",
        },
        {
          value: 8,
          label: "按方购药",
        },
        {
          value: 9,
          label: "拍方购药",
        },
        {
          value: 10,
          label: "开放平台开方",
        },
        {
          value: 11,
          label: "医生拍照开方",
        },
        {
          value: 12,
          label: "web问诊开方",
        },
        {
          value: 13,
          label: "web在线开方",
        },
        {
          value: 14,
          label: "web手机号开方",
        },

        {
          value: 15,
          label: "web微信开方",
        },
        {
          value: 16,
          label: "医生协定方开方",
        },
      ],
      options2: [],
      options3: [
        {
          value: "",
          label: "全部",
        },
        {
          value: 0,
          label: "仅剂量保密",
        },
        {
          value: 1,
          label: "不保密",
        },
        {
          value: 2,
          label: "药材保密",
        },
      ],
      options4: [
        {
          value: "",
          label: "全部",
        },
        {
          value: 1,
          label: "无需确认",
        },
        {
          value: 2,
          label: "待确认",
        },
        {
          value: 3,
          label: "已确认通过",
        },
        {
          value: 4,
          label: "已确认作废",
        },
      ],
      pre_type_list: [
        {
          label: "全部",
          value: "",
        },
        {
          label: "中药材",
          value: 1,
        },
        {
          label: "养生方",
          value: 2,
        },
        {
          label: "成药",
          value: 3,
        },
      ],
      is_test: 2,
      drug_machining: -1,
      selection: [],
      codebox: false,
      codeInfo: {},
      doc_msg: false,
      doctorId: "",
    };
  },
  components: {
    DocMsg,
    myInputSerch,
  },
  filters: {
    preGroupText(val) {
      switch (val) {
        case 0:
          return "养生方";
        case -1:
          return "成药";
      }
    },
    drugMachiningText(val) {
      switch (val) {
        case 0:
          return "";
        case 1:
          return "代煎";
        case 2:
          return "茶包";
      }
    },
  },
  computed: {
    module_id_array() {
      return this.$store.state.userInfo.userInfo.module_id_array;
    },
  },
  created() {
    this.getProvince();
    this.getDrugTypeList();
  },
  activated() {
    if (this.date && this.date.length) {
      this.getList();
    } else {
      const end = new Date();
      const start = new Date();
      start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
      this.date = [start, end];
      this.getList();
    }
  },
  methods: {
    handleSelect(key) {
      this.active = Number(key);
      this.currentPage = 1;
      this.pagesize = 10;
      this.getList();
    },
    //医生信息概要
    showDocMsg(doctor_id) {
      this.doctorId = doctor_id;
      this.doc_msg = !this.doc_msg;
    },
    //获取处方列表
    getList() {
      let data = {
        page: this.currentPage,
        pageNumber: this.pagesize,
        prescription_status: this.active,
        patient_name: this.patient_name,
        doctor_name: this.doctor_name,
        doctor_phone: this.doctor_phone,
        patient_id: 0,
        start_time: "",
        end_time: "",
        pre_type: this.pre_type.toString(),
        is_test: this.is_test,
        drug_type: this.drug_type,
        org_name: this.org_name,
        is_show: this.is_show,
        province_id: this.province_id,
        pre_id: this.pre_id,
        pre_group: this.pre_group,
        hospital_name: this.hospital_name,
        delivery: this.delivery,
        drug_machining: this.drug_machining,
        is_doctor_sure: this.is_doctor_sure,
        is_have: this.is_have,
        action_type: this.action_type,
        treatment_method: this.treatment_method,
      };
      if (this.date && this.date.length > 0) {
        data.start_time = dayjs(this.date[0]).format("YYYY-MM-DD");
        data.end_time = dayjs(this.date[1]).format("YYYY-MM-DD");
      } else {
        data.start_time = "";
        data.end_time = "";
      }
      yewu.prescriptionList(data).then((res) => {
        if (res.code == 0) {
          this.tableData = res.data.list.map((item) => {
            item.create_time = platform.timestampToTime(item.create_time);
            return item;
          });
          this.totalNum = res.data.total;
        }
      });
    },
    //多选
    handleSelectionChange(val) {
      this.selection = val.map((item) => {
        return item.pre_id;
      });
    },
    //获取省市列表
    getProvince() {
      this.axios
        .post("platform/platform/getProvinceCityDistrict")
        .then((res) => {
          this.proList = res.data.list;
        });
    },
    //获取平台开方可以选择的剂型列表
    getDrugTypeList() {
      let platform_type = 3;
      this.axios
        .post("platform/photograph/getDrugTypeList", { platform_type })
        .then((res) => {
          this.options2 = res.data.list;
        });
    },
    //查看详情
    toDetail(pre_id) {
      this.$router.push({
        path: "chufangdetail",
        query: {
          pre_id,
        },
      });
    },
    //发药
    toOrderDetail(order_id) {
      this.$router.push({
        path: "/home/order/orderdetail",
        query: {
          order_id,
        },
      });
    },
    //搜索
    search() {
      this.currentPage = 1;
      this.getList();
    },
    //每页数据
    handleSizeChange(size) {
      this.pagesize = size;
      this.getList();
    },
    //翻页
    handleCurrentChange(currentPage) {
      this.currentPage = currentPage;
      this.getList();
    },
    //生成二维码
    createCode() {
      if (!this.selection.length) {
        this.$message.error("请选择需要操作的处方");
        return false;
      }
      let pre_id = this.selection.toString();
      this.axios
        .post("platform/prescription/getPrescriptionAccountsQrcode", { pre_id })
        .then((res) => {
          if (res.code == 0) {
            if (res.data.status == 0) {
              this.$message.success("二维码生成成功！");
              let accounts_id = res.data.accounts_id;
              this.axios
                .post("platform/prescription/getPrescriptionAccountsInfo", {
                  accounts_id,
                })
                .then((res) => {
                  if (res.code == 0) {
                    this.codeInfo = res.data;
                    this.codeInfo.list = this.codeInfo.list.map((item) => {
                      item.create_time = dayjs
                        .unix(item.create_time)
                        .format("YYYY-MM-DD HH:mm");
                      return item;
                    });
                    this.codebox = true;
                  }
                });
            } else {
              this.$message.error("该二维码记录已存在！");
            }
          }
        });
    },
  },
};
</script>
<style lang="scss" scoped>
.container {
  box-sizing: border-box;
  background-color: #ffffff;
  min-height: calc(100vh - 205px);
  padding-bottom: 20px;
}
.noneline {
  border: 0;
  padding: 0 20px;
}
.title {
  font-size: 16px;
  width: 90px;
}

.mydivider {
  margin: 0;
}

.btnbox {
  text-align: left;
  margin: 20px 0;
  padding-left: 14px;
}
.searchbox {
  display: flex;
  flex-wrap: wrap;
  .item {
    margin-right: 20px;
    margin-top: 16px;
    display: flex;
    align-items: center;
  }
}
.inputclass {
  width: 180px;
  margin-left: 8px;
}
.searchtitle {
  display: inline-block;
  width: 85px;
  text-align: right;
  box-sizing: border-box;
}
</style>
